import * as yup from 'yup';

export const validationSchema = yup.object({
  driversLicenseNumber: yup.string(),
  firstName: yup.string(),
  lastName: yup.string(),
  dateOfBirth: yup.string(),
  class: yup.string(),
  issuingState: yup.string(),
  issueDate: yup.string().required(),
  expireDate: yup.string().required(),
  // restrictions: yup.array().of(yup.string()),
  // endorsements: yup.array().of(yup.string()),
  country: yup.string(),
});
